/// <amd-module name="VSS/Features/Directory/DirectoryConstants" />

export namespace DirectoryFilterKeys {
    export const KEYWORD_FILTER_KEY = "Keyword";
    export const TEAM_FILTER_KEY = "Team";
}
export namespace DirectoryGroupKeys {
    export const MineGroupKey: string = "MINE";
    export const RecentGroupKey: string = "RECENT";
    export const FavoriteGroupKey: string = "FAVORITE";
    export const AllGroupKey: string = "ALL";
}
